import React from 'react';
import { BodyTextMedium } from 'Packages/FacetDesign/Components/BodyText';
import { FDStack } from '@facet-wealth/design';
import Proptypes from 'prop-types';

export const FDWizardSubtitle = ({ value }) => {
  return (
    <FDStack direction={'column'} spacing={1}>
      {value
        // eslint-disable-next-line react/no-array-index-key -- we don't have anything better to use as a key here
        ? value.map((v, i) => <BodyTextMedium key={i} value={v} />)
        : null}
    </FDStack>
  );
};

FDWizardSubtitle.propTypes = {
  value: Proptypes.array.isRequired,
};
